try {
// jsPDF is loaded only when a quote is generated; AMD loaders on the page are hidden while it loads
function lysEnsureJsPdf(cb){
  if (window.jspdf && window.jspdf.jsPDF) return cb();
  var amd = window.define; window.define = undefined;
  var s = document.createElement('script'); s.src = window.LYS_JSPDF_URL;
  s.onload = function(){ window.define = amd; cb(window.jspdf && window.jspdf.jsPDF ? null : new Error('jsPDF did not load')); };
  s.onerror = function(){ window.define = amd; cb(new Error('jsPDF could not be downloaded')); };
  document.head.appendChild(s);
}
function lysQuoteError(form, err){
  console.error('lys-v4 quote', err);
  var p = form.querySelector('.quote-error');
  if (!p) { p = document.createElement('p'); p.className = 'gate-fine quote-error'; p.style.color = '#B3261E'; form.appendChild(p); }
  p.textContent = 'Sorry, the PDF could not be created in this browser. Please try again, or email hello@lystechnologies.io for a quote.';
}

(function(){
  var modal = document.getElementById('quoteModal');
  var form = document.getElementById('quoteForm');
  if (!modal || !form) return;
  var success = document.getElementById('quoteSuccess');
  var v1Input = document.getElementById('quoteQtyV1');
  var proInput = document.getElementById('quoteQtyPro');
  var totalQtyEl = document.getElementById('quoteTotalQty');
  var discountNote = document.getElementById('quoteDiscountNote');
  var tierHint = document.getElementById('quoteTierHint');
  var liveTotal = document.getElementById('quoteLiveTotalValue');
  var redownloadBtn = document.getElementById('quoteRedownload');
  var lastQuote = null;

  // Unit prices, the custom-sampling fee and the currency come from Shopify via window.LYS_PRICES (lys-v4-scripts.liquid),
  // in the visitor's local currency. The fee is derived from the V1 price (GBP 500 at the GBP list price).
  var P = window.LYS_PRICES || { currency: 'GBP', v1: 300, pro: 700, samplingFee: 500 };
  var CUR = P.currency || 'GBP';
  var LOCALES = { GBP: 'en-GB', EUR: 'en-IE', DKK: 'da-DK', USD: 'en-US', SEK: 'sv-SE', NOK: 'nb-NO' };
  var LOCALE = LOCALES[CUR] || 'en-GB';
  var UNIT_PRICE = {'Button V1': P.v1, 'Button PRO': P.pro};
  var TIERS = [
    {min: 1, rate: 0}, {min: 5, rate: 0.10}, {min: 10, rate: 0.15}, {min: 25, rate: 0.20},
    {min: 50, rate: 0.25}, {min: 100, rate: 0.30}
  ];
  var STARTER_RATE = 0.5, STARTER_QTY = 2; // Research Starter intro offer — one per institution
  var starterMode = false;
  var TAILORED_MIN = 250; // 250+ = tailored quote; builder shows the 100–249 price as a ceiling
  function unitFor(name, rate){ return Math.floor(UNIT_PRICE[name] * (1 - rate)); }
  function orderTotal(v1, pro, rate){ return v1 * unitFor('Button V1', rate) + pro * unitFor('Button PRO', rate); }
  function eur0(n){ return new Intl.NumberFormat(LOCALE, {style:'currency', currency:CUR, maximumFractionDigits:0}).format(n); }

  function eur(n){ return new Intl.NumberFormat(LOCALE, {style:'currency', currency:CUR}).format(n); }
  function pct(r){ return (Math.round(r * 1000) / 10) + '%'; }

  function getDiscountRate(qty){
    var rate = 0;
    for (var i = 0; i < TIERS.length; i++){ if (qty >= TIERS[i].min) rate = TIERS[i].rate; }
    return rate;
  }
  // loss-framed nudge: tell buyers when moving up a tier costs the same or less
  function nextTierHint(v1, pro){
    var qty = v1 + pro;
    if (qty >= TAILORED_MIN) return {text: qty + ' Buttons qualifies for a tailored project quote. Your PDF shows the 100–249 price as a ceiling, and our team will follow up.', nudge: true};
    var rate = getDiscountRate(qty), now = orderTotal(v1, pro, rate);
    for (var i = 0; i < TIERS.length; i++){
      if (TIERS[i].min > qty){
        var add = TIERS[i].min - qty;
        // add the extra Buttons to whichever line is larger (V1 if tied)
        var nv1 = v1 >= pro ? v1 + add : v1, npro = v1 >= pro ? pro : pro + add;
        var then = orderTotal(nv1, npro, TIERS[i].rate);
        var label = add + ' more Button' + (add === 1 ? '' : 's');
        if (then <= now) return {text: 'Add ' + label + ' and your whole order costs ' + (then < now ? eur0(now - then) + ' less' : 'the same') + ', with ' + pct(TIERS[i].rate) + ' off everything, plus spares for your study.', nudge: true};
        return {text: 'Add ' + label + ' to reach ' + pct(TIERS[i].rate) + ' off every Button (V1 ' + eur0(unitFor('Button V1', TIERS[i].rate)) + ' · PRO ' + eur0(unitFor('Button PRO', TIERS[i].rate)) + ').', nudge: false};
      }
    }
    return {text: 'Need 250+ Buttons? Contact us for a tailored project quote.', nudge: false};
  }

  var sampSel = document.getElementById('quoteSampling'), sampCustom = document.getElementById('quoteSamplingCustom'),
      sampV1 = document.getElementById('quoteSamplingV1'), sampPro = document.getElementById('quoteSamplingPro'),
      sampNote = document.getElementById('quoteSamplingNote'), SAMPLING_INCLUDED_FROM = 25;
  var CUSTOM_SAMPLING_FEE = P.samplingFee || Math.round(P.v1 * 5 / 3);
  function samplingState(v1, pro, isStarter){
    var qty = v1 + pro;
    var customOpt = sampSel.querySelector('option[value="custom"]');
    customOpt.disabled = false;
    var custom = sampSel.value === 'custom';
    sampCustom.hidden = !custom;
    document.getElementById('qsV1Wrap').style.display = v1 > 0 ? '' : 'none';
    document.getElementById('qsProWrap').style.display = pro > 0 ? '' : 'none';
    if (!custom) {
      sampNote.hidden = true;
      return {custom:false, fee:0, detail:'Standard - every 15 seconds'};
    }
    var parts = [];
    if (v1 > 0) parts.push('V1: ' + sampV1.options[sampV1.selectedIndex].text);
    if (pro > 0) parts.push('PRO: ' + sampPro.options[sampPro.selectedIndex].text);
    var included = qty >= SAMPLING_INCLUDED_FROM;
    var maxBatt = (pro > 0 && v1 === 0) ? '7 days (PRO)' : (v1 > 0 && pro === 0) ? '5 days (V1)' : '5 days (V1) and 7 days (PRO)';
    sampNote.hidden = false;
    sampNote.textContent = (included ? 'Custom sampling is included for orders of 25+ Buttons. ' : 'Custom sampling: ' + eur0(CUSTOM_SAMPLING_FEE) + ' per order (excl. VAT) below 25 Buttons, included from 25 Buttons. ') +
      'Battery life is ' + maxBatt + ', so longer recordings need recharging.';
    return {custom:true, included:included, fee: included ? 0 : CUSTOM_SAMPLING_FEE, detail: parts.join(' | ').replace(/≈/g,'approx. ').replace(/\(/g,'(storage ').replace(/—/g,'-').replace(/~/g,'approx. ')};
  }
  [sampSel, sampV1, sampPro].forEach(function(el){ el.addEventListener('change', function(){ recalc(); }); });

  function recalc(){
    var v1 = Math.max(0, parseInt(v1Input.value, 10) || 0);
    var pro = Math.max(0, parseInt(proInput.value, 10) || 0);
    var qty = v1 + pro;
    var isStarter = starterMode && qty === STARTER_QTY;
    var rate = isStarter ? STARTER_RATE : getDiscountRate(qty);
    var subtotal = v1 * UNIT_PRICE['Button V1'] + pro * UNIT_PRICE['Button PRO'];
    var samp = samplingState(v1, pro, isStarter);
    var total = orderTotal(v1, pro, rate);
    var discountAmt = subtotal - total;
    total += samp.fee;
    subtotal += samp.fee;

    totalQtyEl.textContent = String(qty) + (qty === 1 ? ' Button' : ' Buttons');
    discountNote.textContent = isStarter ? 'Research Starter · 50% off' : qty >= TAILORED_MIN ? 'Tailored quote (250+)' : rate > 0 ? (pct(rate) + ' off · save ' + eur0(discountAmt)) : 'None below 5 Buttons';
    var hint = qty > 0 ? nextTierHint(v1, pro) : {text: 'Enter your V1 and PRO quantities above.', nudge: false};
    if (isStarter) hint = {text: 'Research Starter introductory offer: 50% off 2 Buttons, limited to one purchase per customer. Change the quantity to switch to standard volume pricing.', nudge: true};
    tierHint.textContent = hint.text;
    tierHint.classList.toggle('nudge', !!hint.nudge);
    tierHint.style.color = '';
    liveTotal.textContent = eur(total);

    if (samp.custom && !samp.included && qty > 0) {
      var add = SAMPLING_INCLUDED_FROM - qty;
      var nv1 = v1 >= pro ? v1 + add : v1, npro = v1 >= pro ? pro : pro + add;
      var t25 = orderTotal(nv1, npro, getDiscountRate(SAMPLING_INCLUDED_FROM));
      var diff = t25 - total;
      if (diff <= 2 * CUSTOM_SAMPLING_FEE) hint = {text: 'Add ' + add + ' more Button' + (add === 1 ? '' : 's') + ' and custom sampling is included: ' + (diff <= 0 ? 'your total drops by ' + eur0(-diff) : 'only ' + eur0(diff) + ' more') + ', at ' + pct(getDiscountRate(SAMPLING_INCLUDED_FROM)) + ' off every Button.', nudge: true};
      tierHint.textContent = hint.text; tierHint.classList.toggle('nudge', !!hint.nudge);
    }
    var lineItems = [];
    if (v1 > 0) lineItems.push({name: 'Button V1', unitPrice: UNIT_PRICE['Button V1'], qty: v1, lineTotal: v1 * unitFor('Button V1', rate)});
    if (pro > 0) lineItems.push({name: 'Button PRO', unitPrice: UNIT_PRICE['Button PRO'], qty: pro, lineTotal: pro * unitFor('Button PRO', rate)});

    if (samp.custom) lineItems.push({name: 'Custom sampling configuration', special: true, qty: 1, unitText: samp.included ? 'Included' : eur(samp.fee), lineText: samp.included ? 'Included' : eur(samp.fee), detail: samp.detail});
    return {sampling: samp, starter: isStarter, v1: v1, pro: pro, qty: qty, rate: rate, subtotal: subtotal, discountAmt: discountAmt, total: total, lineItems: lineItems};
  }

  function openModal(trigger){
    starterMode = trigger.getAttribute('data-tier') === 'starter';
    sampSel.value = trigger.getAttribute('data-sampling') === 'custom' ? 'custom' : 'standard';
    var v1 = trigger.getAttribute('data-v1');
    var pro = trigger.getAttribute('data-pro');
    if (v1 !== null || pro !== null) {
      v1Input.value = v1 !== null ? v1 : 0;
      proInput.value = pro !== null ? pro : 0;
    } else {
      // backward-compatible single-product triggers (data-product / data-price / data-qty)
      var product = trigger.getAttribute('data-product');
      var presetQty = parseInt(trigger.getAttribute('data-qty'), 10);
      var qty = presetQty > 0 ? presetQty : 10;
      if (product === 'Button PRO') { proInput.value = qty; v1Input.value = 0; }
      else { v1Input.value = qty; proInput.value = 0; }
    }
    recalc();
    form.classList.remove('hidden');
    success.classList.remove('shown');
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeModal(){
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.quote-trigger').forEach(function(btn){
    btn.addEventListener('click', function(){ openModal(btn); });
  });
  document.querySelectorAll('[data-quote-close]').forEach(function(el){
    el.addEventListener('click', closeModal);
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && modal.classList.contains('open')) closeModal();
  });
  v1Input.addEventListener('input', recalc);
  proInput.addEventListener('input', recalc);

  function buildQuotePdf(data){
    var jsPDF = window.jspdf.jsPDF;
    var doc = new jsPDF({unit: 'mm', format: 'a4'});
    var ink = [33,35,34], muted = [107,110,109], line = [221,221,221], accent = [241,180,52];
    function setText(c){ doc.setTextColor(c[0], c[1], c[2]); }
    function setDraw(c){ doc.setDrawColor(c[0], c[1], c[2]); }

    // Letterhead: the real LYS logo (window.LYS_QUOTE_LOGO, assets/lys-v4-quote-logo.js) with the company name small beside it
    var logoDrawn = false;
    if (window.LYS_QUOTE_LOGO) {
      try { doc.addImage(window.LYS_QUOTE_LOGO, 'PNG', 21, 19.5, 17, 8.15); logoDrawn = true; } catch (e) { console.error('lys-v4 quote logo', e); }
    }
    if (logoDrawn) {
      doc.setFont('helvetica', 'normal'); doc.setFontSize(9); setText(muted);
      doc.text('LYS Technologies', 42, 26);
    } else {
      doc.setFont('helvetica', 'bold'); doc.setFontSize(14); setText(ink);
      doc.text('LYS TECHNOLOGIES', 21, 26);
    }
    setDraw(accent); doc.setLineWidth(1.2); doc.line(21, 31, 189, 31);

    doc.setFont('helvetica', 'normal'); doc.setFontSize(9); setText(muted);
    doc.text('OFFICIAL RESEARCH QUOTE · NON-BINDING', 21, 40);
    doc.setFont('helvetica', 'bold'); doc.setFontSize(20); setText(ink);
    doc.text('Official Research Quote', 21, 50);

    doc.setFont('helvetica', 'normal'); doc.setFontSize(10); setText(muted);
    doc.text('Quote number: ' + data.quoteNumber, 21, 59);
    doc.text('Date: ' + data.dateStr, 21, 65);
    doc.text('Valid until: ' + data.validUntilStr, 21, 71);

    doc.setFont('helvetica', 'bold'); doc.setFontSize(10); setText(ink);
    doc.text('Prepared for', 130, 59);
    doc.setFont('helvetica', 'normal'); setText(muted);
    doc.text(data.institution, 130, 65);
    doc.text(data.contact, 130, 71);
    doc.text(data.email, 130, 77);
    if (data.po) doc.text('Ref: ' + data.po, 130, 83);

    var tableTop = 96;
    setDraw(line); doc.setLineWidth(0.3); doc.line(21, tableTop, 189, tableTop);
    doc.setFont('helvetica', 'bold'); doc.setFontSize(9.5); setText(ink);
    doc.text('PRODUCT', 21, tableTop + 7);
    doc.text('UNIT PRICE', 100, tableTop + 7);
    doc.text('QTY', 130, tableTop + 7);
    doc.text('DISCOUNT', 150, tableTop + 7);
    doc.text('LINE TOTAL', 175, tableTop + 7);
    doc.line(21, tableTop + 10, 189, tableTop + 10);

    doc.setFont('helvetica', 'normal'); setText(ink);
    var rowY = tableTop + 18;
    var items = data.lineItems.length ? data.lineItems : [{name: '—', unitPrice: 0, qty: 0, lineTotal: 0}];
    items.forEach(function(item, i){
      var y = rowY + i * 8;
      doc.text(item.name, 21, y);
      if (item.special) {
        doc.text(item.unitText, 100, y); doc.text('1', 130, y); doc.text('—', 150, y); doc.text(item.lineText, 175, y);
      } else {
        doc.text(eur(item.unitPrice), 100, y);
        doc.text(String(item.qty), 130, y);
        doc.text(data.rate > 0 ? pct(data.rate) : '—', 150, y);
        doc.text(eur(item.lineTotal), 175, y);
      }
    });
    var lastRowY = rowY + (items.length - 1) * 8;
    doc.line(21, lastRowY + 6, 189, lastRowY + 6);

    var sampLine = 'Sampling: ' + (data.sampling && data.sampling.custom ? data.sampling.detail : 'Standard - every 15 seconds (approx. 24 h storage on V1, approx. 10 h on PRO)');
    doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5); setText(muted);
    var sampLines = doc.splitTextToSize(sampLine, 168); doc.text(sampLines, 21, lastRowY + 13);
    lastRowY += sampLines.length * 4.5;
    doc.setFontSize(9.5); setText(ink);
    var sumY = lastRowY + 16;
    doc.setFont('helvetica', 'normal'); doc.setFontSize(9.5); setText(muted);
    doc.text('Combined sensors', 130, sumY);
    doc.text(String(data.qty), 189, sumY, {align: 'right'});
    doc.text('Subtotal', 130, sumY + 7);
    doc.text(eur(data.subtotal), 189, sumY + 7, {align: 'right'});
    doc.text('Discount (' + (data.rate > 0 ? pct(data.rate) : '0%') + ')', 130, sumY + 14);
    doc.text('-' + eur(data.discountAmt), 189, sumY + 14, {align: 'right'});
    setDraw(line); doc.line(130, sumY + 18, 189, sumY + 18);
    doc.setFont('helvetica', 'bold'); doc.setFontSize(13); setText(ink);
    doc.text('Total', 130, sumY + 27);
    doc.text(eur(data.total), 189, sumY + 27, {align: 'right'});
    doc.setFont('helvetica', 'normal'); doc.setFontSize(7.5); setText(muted);
    doc.text('excl. VAT', 130, sumY + 32);

    var noteY = sumY + 41;
    setDraw(line); doc.line(21, noteY, 189, noteY);
    doc.setFont('helvetica', 'italic'); doc.setFontSize(8.5); setText(muted);
    doc.text(doc.splitTextToSize(
      'This is a non-binding quote generated instantly on the LYS Technologies website. All amounts are in ' + CUR + '. ' +
      'The volume-discount tier is based on combined Button V1 + Button PRO quantity and applies equally to both product lines; discounted unit prices are rounded down to whole currency units. ' +
      (data.starter ? 'Research Starter introductory offer (50% off): limited to one purchase per customer; LYS may decline or re-price duplicate orders. ' : '') +
      (data.sampling && data.sampling.custom ? (data.sampling.included ? 'Custom sampling is included for orders of 25+ Buttons. ' : 'Custom sampling is a one-off fee of ' + eur0(CUSTOM_SAMPLING_FEE) + ' per order below 25 Buttons, included in the total above. ') + 'LYS configures custom sampling before dispatch and confirms the settings in writing; storage figures are approximate and battery life (V1 5 days, PRO 7 days) is unchanged. ' : '') +
      (data.qty >= 250 ? 'Orders of 250+ Buttons qualify for a tailored project quote - the total above is a ceiling and our team will follow up. ' : '') +
      'Final pricing, VAT/tax, shipping and delivery terms are confirmed by our sales team upon order.',
      168), 21, noteY + 7);

    doc.setFont('helvetica', 'normal'); doc.setFontSize(8); setText(muted);
    doc.text('LYS Technologies A/S  ·  hello@lystechnologies.io', 21, 280);

    return doc;
  }

  form.addEventListener('submit', function(e){
    e.preventDefault();
    if (!form.checkValidity()) { form.reportValidity(); return; }
    var calc = recalc();
    if (calc.qty < 1) { tierHint.textContent = 'Enter at least one V1 or PRO sensor to generate a quote.'; tierHint.style.color = '#c0392b'; return; }
    var now = new Date();
    var quoteNumber = 'LYS-Q-' + now.getFullYear() + '-' + String(Math.floor(Math.random()*90000) + 10000);
    var validUntil = new Date(now.getTime() + 30*24*60*60*1000);
    var fmtDate = function(d){ return d.toLocaleDateString('en-GB', {day:'2-digit', month:'short', year:'numeric'}); };

    var data = {
      quoteNumber: quoteNumber,
      dateStr: fmtDate(now),
      validUntilStr: fmtDate(validUntil),
      institution: document.getElementById('quoteInstitution').value.trim(),
      contact: (document.getElementById('quoteFirstName').value.trim() + ' ' + document.getElementById('quoteLastName').value.trim()).trim(),
      email: document.getElementById('quoteEmail').value.trim(),
      po: document.getElementById('quotePO').value.trim(),
      lineItems: calc.lineItems,
      qty: calc.qty,
      rate: calc.rate,
      starter: calc.starter,
      sampling: calc.sampling,
      subtotal: calc.subtotal,
      discountAmt: calc.discountAmt,
      total: calc.total
    };
    lastQuote = data;

    var submitBtn = form.querySelector('[type=submit]'); if (submitBtn) submitBtn.disabled = true;
    // HubSpot "Website quote request" first; the PDF is made whether or not that succeeds
    var pricing = calc.starter ? 'Research Starter 50%' : calc.qty >= TAILORED_MIN ? 'Tailored quote (250+), 30% shown as ceiling'
      : calc.rate > 0 ? pct(calc.rate) + ' volume discount' : 'List price (no discount)';
    var sampling = calc.sampling.custom ? 'Custom: ' + calc.sampling.detail + (calc.sampling.included ? ' (included)' : ' (' + CUR + ' ' + CUSTOM_SAMPLING_FEE + ' fee)') : 'Standard - every 15 seconds';
    var fields = [
      { name: 'firstname', value: document.getElementById('quoteFirstName').value },
      { name: 'lastname', value: document.getElementById('quoteLastName').value },
      { name: 'email', value: data.email },
      { name: 'company', value: data.institution },
      { name: 'quote_number', value: quoteNumber },
      { name: 'quote_v1_quantity', value: calc.v1 },
      { name: 'quote_pro_quantity', value: calc.pro },
      { name: 'quote_pricing', value: pricing + ' (' + CUR + ')' },
      { name: 'quote_total_excl_vat', value: Math.round(calc.total * 100) / 100 },
      { name: 'quote_sampling', value: sampling },
      { name: 'quote_reference', value: data.po }
    ];
    var hp = document.getElementById('quoteHpCheck');
    var send;
    if (hp && hp.value.trim()) { if (window.LYS_HS) LYS_HS.debug('quote: hidden anti-spam field was filled, nothing sent'); send = Promise.resolve(); } // honeypot filled: likely a bot
    else send = window.LYS_HS ? window.LYS_HS.submit('quote', fields) : Promise.resolve();
    send.then(function(){ lysEnsureJsPdf(function(err){
      if (submitBtn) submitBtn.disabled = false;
      if (err) { lysQuoteError(form, err); return; }
      try { buildQuotePdf(data).save('LYS-Quote-' + quoteNumber + '.pdf'); }
      catch (e) { lysQuoteError(form, e); return; }
      form.classList.add('hidden');
      success.classList.add('shown');
    }); });
  });

  redownloadBtn.addEventListener('click', function(){
    if (!lastQuote) return;
    var doc = buildQuotePdf(lastQuote);
    doc.save('LYS-Quote-' + lastQuote.quoteNumber + '.pdf');
  });

  // deep-link: About page's "Get a quote" links here with ?openQuote=1
  var qp = new URLSearchParams(location.search);
  if (qp.get('openQuote')) {
    var headerTrigger = document.querySelector('.quote-trigger');
    if (headerTrigger) openModal(headerTrigger);
  }
})();
} catch (e) { console.error("lys-v4 quote", e); }
